module.exports = ".home {\n  text-align: center;\n  font-weight: 300; }\n  .home img {\n    max-width: 100%;\n    max-height: 100%; }\n  .home h1 {\n    text-transform: uppercase; }\n  .home h4 a, .home h4 a:hover, .home h4 a:focus, .home h4 a:active {\n    color: #FFF;\n    text-decoration: none; }\n  .home h4 a span, .home h4 a:hover span, .home h4 a:focus span, .home h4 a:active span {\n      font-size: 18pt;\n      color: #b85614; }\n  /*# sourceMappingURL=home.component.css.map */\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.css
// module id = ./src/app/home/home.component.css
// module chunks = main